module.exports = __webpack_public_path__ + "img/img4.fb13b69a.png";